import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';

const HowToPage = () => {
    const { t } = useTranslation();

    const guides = [
        {
            title: t('howToMarketplace.title', 'How to List Item'),
            desc: t('howToMarketplace.desc', 'Learn how to list your items for sale or post a buy request.'),
            link: '/how-to-marketplace',
            icon: <ShoppingBag className="w-8 h-8 text-blue-600" />
        }
    ];

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('howTo.title')}</h1>
                <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    {t('howTo.subtitle')}
                </p>
            </div>

            <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6">
                {guides.map((guide, index) => (
                    <Link
                        key={index}
                        to={guide.link}
                        className="flex items-start gap-4 p-6 bg-white border border-gray-200 rounded-xl hover:border-blue-500 hover:shadow-md transition group"
                    >
                        <div className="p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition">
                            {guide.icon}
                        </div>
                        <div>
                            <h3 className="text-xl font-semibold mb-2 text-gray-900 group-hover:text-blue-600 transition">{guide.title}</h3>
                            <p className="text-gray-600">{guide.desc}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default HowToPage;
